import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
import "firebase/storage"
import "firebase/analytics"
import "firebase/messaging"

// firebase init goes here
const config = {
	apiKey: "AIzaSyCcilcBJXLBK-UVJcrMTwp63UUJFWHM6DU",
    authDomain: "district-conference-7030.firebaseapp.com",
    databaseURL: "https://district-conference-7030.firebaseio.com",
    projectId: "district-conference-7030",
    storageBucket: "district-conference-7030.appspot.com",
    messagingSenderId: "930121145857",
    appId: "1:930121145857:web:f250af14928b6bdc69ea00",
    measurementId: "G-ERHW6V9J1F"
}

firebase.initializeApp(config)
firebase.analytics()

const db = firebase.firestore()
const storageRef = firebase.storage().ref()
const auth = firebase.auth()
var messaging = false
if(firebase.messaging.isSupported()){
    messaging = firebase.messaging ()
    messaging.getToken({ vapidKey: "BES-TbxDB9VUU7SQY03yWD2GLjDZXTDhHjQ5DUKwmoOy1l39imjBNhFI1J-fl_NWVuYvG2CXOu91DGez3DKvLXE" })
}


// firebase collections
const fcmtokensCollection = db.collection("si_fcmtokens")
const usersCollection = db.collection("users")
const confeventsCollection = db.collection("confevents")
const confticketsCollection = db.collection("conftickets")
const ordersCollection = db.collection("orders")
const confoverviewCollection = db.collection("si_fcmtokens")
const settingsCollection = db.collection("settings")
const adminEmailCollection = db.collection("admin_mail")

export {
    firebase,
    db,
    auth,
    messaging,
    storageRef,
    fcmtokensCollection,
    usersCollection,
    confeventsCollection,
    confticketsCollection,
    ordersCollection,
    confoverviewCollection,
    settingsCollection,
    adminEmailCollection
}